import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import d18 from './Pricing.module.css';

import { FaPaperPlane, FaRocket } from 'react-icons/fa'
import { IoBalloon } from 'react-icons/io5'
import { GiFrance, GiUsaFlag } from 'react-icons/gi';
function Pricing() {
  return (
    <div>


      <section>
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className={"col-sm-6 col-md-4  " + d18.cardContainer}>
                <div className={d18.card + " text-center"}>
                  <div className={d18.title}>
                    <div className={d18.fa}><IoBalloon /></div>
                    <h2>Basic</h2>
                  </div>
                  <div className={d18.price}>
                    <h4><sup>$</sup>8</h4>
                  </div>
                  <div className={d18.option}>
                    <ul>
                      <li><u><b>20</b> Questions</u></li>
                      <li> <b>All Subjects</b> Support</li>
                      <li> <b>Pre-</b>Exams Webinars</li>
                      <li>Full Day Support </li>
                      <li>Rich Media</li>
                      <li>Multilingual </li>
                    </ul>
                  </div>
                  <Link to='/subscription-form'>Order Now </Link>
                </div>
              </div>


              <div className={"col-sm-6 col-md-4  " + d18.cardContainer}>
                <div className={d18.card + " text-center"}>
                  <div className={d18.title}>
                    <div className={d18.fa}><FaPaperPlane /></div>
                    <h2>Standard</h2>
                  </div>
                  <div className={d18.price}>
                    <h4><sup>$</sup>13</h4>
                  </div>
                  <div className={d18.option}>
                    <ul>
                      <li><u><b>40</b> Questions</u></li>
                      <li> <b>All Subjects</b> Support</li>
                      <li> <b>Pre-</b>Exams Webinars</li>
                      <li>Full Day Support </li>
                      <li>Rich Media</li>
                      <li>Multilingual </li>
                    </ul>
                  </div>
                  <Link to='/subscription-form'>Order Now </Link>
                </div>
              </div>


              <div className={"col-sm-6 col-md-4  " + d18.cardContainer}>
                <div className={d18.card + " text-center"}>
                  <div className={d18.title}>
                    <div className={d18.fa}><FaRocket /></div>
                    <h2>Premium</h2>
                  </div>
                  <div className={d18.price}>
                    <h4><sup>$</sup>17</h4>
                  </div>
                  <div className={d18.option}>
                    <ul>
                      <li><u><b>60</b> Questions</u></li>
                      <li> <b>All Subjects</b> Support</li>
                      <li> <b>Pre-</b>Exams Webinars</li>
                      <li>Full Day Support </li>
                      <li>Rich Media</li>
                      <li>Multilingual </li>
                    </ul>
                  </div>
                  <Link to='/subscription-form'>Order Now </Link>
                </div>
              </div>

              <div className={"col-sm-6 col-md-4  " + d18.cardContainer}>
                <div className={d18.card + " text-center"}>
                  <div className={d18.title}>
                    <div className={d18.fa}><GiUsaFlag /></div>
                    <h2>SAT Support Package</h2>
                  </div>
                  <div className={d18.price}>
                    <h4><sup>$</sup>100</h4>
                  </div>
                  <div className={d18.option}>
                    <ul>
                      <li><u><b>8</b> Saturdays</u></li>
                      <li> <b>32 hrs</b> In Total</li>
                      <li> <b>2 hrs</b> English</li>
                      <li> <b>2 hrs</b> Math</li>
                      <li>For Beginners and advanced</li>
                      <li>Certified tutors</li>
                    </ul>
                  </div>
                  <a target="_blank" href={"https://wa.me/96181184763?text= hello%2c%20%0Ai%20am%20interested%20in%20the%20SAT%20package%2c%20i%20would%20like%20to%20book%20a%20place%20and%20get%20more%20details%20about%20this%20service"} rel="noreferrer">Book Now</a>
                </div>
              </div>

              <div className={"col-sm-6 col-md-4  " + d18.cardContainer}>
                <div className={d18.card + " text-center"}>
                  <div className={d18.title}>
                    <div className={d18.fa}><GiFrance /></div>
                    <h2>DELF Support Package</h2>
                  </div>
                  <div className={d18.price}>
                    <h4><sup>$</sup>50</h4>
                  </div>
                  <div className={d18.option}>
                    <ul>
                      <li><u><b>8</b> Saturdays</u></li>
                      <li> <b>2 hrs</b> Preparation</li>
                      <li><b>Vocabulary</b> and <b>grammar</b> explanation</li>

                      <li>For Beginners and advanced</li>
                      <li>Certified tutors</li>
                    </ul>
                  </div>
                  <a target="_blank" href={"https://wa.me/96181184763?text= hello%2c%20%0Ai%20am%20interested%20in%20the%20DELF%20package%2c%20i%20would%20like%20to%20book%20a%20place%20and%20get%20more%20details%20about%20this%20service"} rel="noreferrer">Book Now</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


      {/*             
            <div className={d18.Pricing}>Pricing:</div>
         <div className={d18.PricingPackage}>
             <div className={d18.PackageName}>Standard</div>
             <div className={d18.Price}>12 $ <div className={d18.per}></div></div>
             <ul>
                <li><b>40</b> Questions</li>
                <li> <b>All Subjects</b> Support</li>
                <li> <b>Pre-</b>Exams Webinars</li>
                <li>Full Day Support </li>
                <li>Rich Media</li>
                <li>Multilingual </li>
                
             </ul>
             <button onClick={()=> hist('/subscription-form',{push:true})}> Request Now!</button>
             </div>    */}
    </div>
  )
}

export default Pricing
